<template>
    <div>
        <div v-if="modEmails.length <= 0" class="text-sm italic text-red-700">{{ $t('No email assigned') }}</div>
        <div v-for="(email, index) in modEmails" class="inline-flex w-full mt-1 relative rounded-md shadow-sm">
            <select
                :id="'email_' + index + '_type'"
                v-model="email.environment"
                class="block form-select w-4/12 xl:w-48 py-1 bg-gray-200 rounded-l-sm rounded-r-none shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            >
                <option :value="null" disabled>{{ $t('Select an option') }}</option>
                <option v-for="environment in environmentList" :value="environment">{{ environment.toUpperCase() }}</option>
            </select>
            <input
                :id="'email_' + index + '_name'"
                v-model="email.name"
                :placeholder="$t('User')"
                class="form-input block w-4/12 xl:w-5/12 py-1 pr-1 border-l-0 border-r-0 rounded-none transition duration-150 ease-in-out text-right sm:text-sm sm:leading-5 focus:z-10"
                type="text"
                @input="setDirty(true)"
            >
            <div class="form-input px-0 xl:px-1 py-1 rounded-none border-l-0 border-r-0 text-center sm:text-sm sm:leading-5">
                @
            </div>
            <input
                :id="'email_' + index + '_domain'" 
                v-model="email.domain"
                :placeholder="$t('Domain')"
                class="form-input block w-4/12 xl:w-7/12 py-1 pl-1 border-l-0 border-r-0 rounded-none transition duration-150 ease-in-out sm:text-sm sm:leading-5 focus:z-10"
                type="text"
                @input="setDirty(true)"
            >
            <button
                class="btn btn-red py-0 px-1 xl:px-2 shadow-sm rounded-l-none rounded-r-sm"
                type="button"
                @click="deleteEmail(index)"
            >
                <svg-vue class="h-4 w-4 p-px text-red-800" icon="font-awesome.times-light"></svg-vue>
            </button>
        </div>
        <div class="mt-2">
            <button
                class="btn btn-secondary py-1 px-2 shadow-sm rounded-sm"
                type="button"
                @click="newEmail()"
            >
                <div class="flex gap-x-1">
                    <svg-vue class="h-4 w-4 text-green-300" icon="font-awesome.plus-solid"></svg-vue>
                    <div class="text-xs text-gray-300 leading-4">{{ $t('Add email') }}</div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-phone",
    props: {
        emailList: {
            type: Array,
            required: true
        },
    },
    watch: {
        emailList() {
            this.modEmails = [...this.emailList];
            this.outEmails = [...this.emailList];
        },
    },
    data() {
        return {
            emailTemplate: {
                id: null,
                name: null,
                domain: null,
                environment: null
            },
            modEmails: [],
            outEmails: [],
            environmentList: [],
            dirty: false
        }
    },
    mounted() {
        this.getEnvironments();
    },
    methods: {
        getEnvironments() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/emails/environments').then((response) => {
                self.environmentList = response.data.environments;
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        async saveEmails() {
            const self = this;
            if (self.dirty) {
                let requests = [];
                self.outEmails = [];
                for (let i = 0; i < self.modEmails.length; i++) {
                    if (self.checkEmail(i)) {
                        requests.push(axios.post('api/dashboard/admin/emails', self.modEmails[i]).then((response) => {
                            if (response.data.status != "error") {
                                response.data.email.environment = self.modEmails[i].environment;
                                self.outEmails.splice(i, 0, response.data.email);
                            };
                        }).catch(() => {
                            //
                        }));
                    }
                }
                await Promise.all(requests);
                self.setDirty(false);
                return self.outEmails;
            }
            return self.modEmails;
        },
        newEmail() {
            this.modEmails.push({...this.emailTemplate});
            this.setDirty(true);
        },
        deleteEmail(index) {
            this.modEmails.splice(index, 1);
            this.setDirty(true);
        },
        checkEmail(index) {
            return this.modEmails[index].name && this.modEmails[index].domain && this.modEmails[index].environment;
        },
        setDirty(value) {
            this.dirty = value;
        },
        getEmailIDs() {
            return this.outEmails.map(email => email.id);
        }
    }
}
</script>
